import { NewsfeedResultApi } from './notifications.backend-model';

declare module '../core/backend' {
  interface BackendApiFetchTypes {
    notifications: NewsfeedResultApi;
  }
}

export const notificationsBackend = {
  fetch: () => ({
    endpoint: `newsfeed/0.1/newsfeed/notifications`,
    params: {},
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/notifications/notifications.backend.ts